/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Snapshotform_Createtitle3Inputs */

const en_coinvestments_report_snapshotform_createtitle3 = /** @type {(inputs: Coinvestments_Report_Snapshotform_Createtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add quarterly data`)
};

/**
* | output |
* | --- |
* | "Add quarterly data" |
*
* @param {Coinvestments_Report_Snapshotform_Createtitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_snapshotform_createtitle3 = /** @type {((inputs?: Coinvestments_Report_Snapshotform_Createtitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Snapshotform_Createtitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_snapshotform_createtitle3(inputs)
});
export { coinvestments_report_snapshotform_createtitle3 as "coInvestments_report_snapshotForm_createTitle" }